<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >

        <a-form-item label="类型">
          {{ data.type }}
        </a-form-item>

        <a-form-item label="名称">
          <a-input
            v-decorator="['name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入名称' },
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item v-if="data.has_parent" :label="parentTypeName">
          <a-select
            v-decorator="['parent_id', {
              rules: [
                { required: true, message: '请选择' + parentTypeName }
              ]
            }]"
            :loading="loadingParentOptions"
            allow-clear
            show-search
            option-filter-prop="children"
          >
            <a-select-option
              v-for="option in parentOptions"
              :key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-else-if="data.sub_type_slug" label="Slug">
          {{ data.sub_type_slug }}
        </a-form-item>

        <a-form-item label="说明">
          <a-textarea
            v-decorator="['description', {
              rules: [
                { max: 200, message: '最多200个字符' }
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeForm, updateCommonType, findCommonTypeOptions } from '@/api/common_type'

export default {
  name: 'EditCommonType',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'common_type' }),
      submitting: false,
      data: {},
      parentTypeName: '关联类型',
      parentTypeSlug: '',
      loadingParentOptions: false,
      parentOptions: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findCommonTypeForm(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.form.setFieldsValue({
            name: res.data.name,
            description: res.data.description,
            parent_id: res.data.parent_id || undefined
          })
          if (res.data.has_parent) {
            this.parentTypeName = res.data.parent_type_name || '关联类型'
            this.parentTypeSlug = res.data.parent_type_slug
            this.fetchParentOptions()
          }
        }
      })
    },

    fetchParentOptions() {
      if (!this.parentTypeSlug) {
        return
      }
      this.loadingParentOptions = true
      findCommonTypeOptions(this.parentTypeSlug).then((res) => {
        if (res.code === 0) {
          this.parentOptions = res.data
        }
        this.loadingParentOptions = false
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = {
            ...values
          }
          updateCommonType(this.id, data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }

  }
}
</script>
